 
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import { createLogger } from 'redux-logger';

import app from './app-dux/app-dux';
import company from './app-dux/company-dux';
import bulkGiftCodesPage from './components/routes/bulk-gift-codes/bulk-gift-codes-dux.js';
import giftCodesSearchPage from './components/routes/gift-codes-lookup/gift-codes-search-dux.js';

/*******************************************************************************
 *  Gather all the reducers
 */
const reducer = combineReducers( {
    app,
    company,
    bulkGiftCodesPage,
    giftCodesSearchPage
} );

const middleware = [ thunk ];

//if ( window.location.port === '5000' ) {
    middleware.push( createLogger( {
        collapsed: true
    } ) );
//}

const AppStore = createStore(
    reducer,
    applyMiddleware( ...middleware )
);
export default AppStore;